import PropTypes from "prop-types";
import { Loader } from "components/Loader";
import { ButtonContainer } from "./v2/Button.styles";

export const Button = ({
  variant = "primary",
  size = "medium",
  label,
  width,
  className = "",
  children,
  isLoading = false,
  disabled = false,
  ...props
}) => {
  return (
    <ButtonContainer
      type="button"
      className={[`button-${size}`, `button-${variant}`, className].join(" ")}
      style={width ? { width } : undefined}
      disabled={isLoading || disabled}
      {...props}
    >
      {isLoading ? (
        <Loader
          className="on-btn"
          variant={variant === "dark" ? "light" : undefined}
        />
      ) : (
        children ?? label
      )}
    </ButtonContainer>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "outlined",
    "link",
    "dark",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  label: PropTypes.string,
  onClick: PropTypes.func,
  width: PropTypes.any,
  className: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

Button.displayName = "Button";
